import { render, staticRenderFns } from "./CustomisedRequestCard.vue?vue&type=template&id=0ce66cd6"
import script from "./CustomisedRequestCard.vue?vue&type=script&lang=ts"
export * from "./CustomisedRequestCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ce66cd6')) {
      api.createRecord('0ce66cd6', component.options)
    } else {
      api.reload('0ce66cd6', component.options)
    }
    module.hot.accept("./CustomisedRequestCard.vue?vue&type=template&id=0ce66cd6", function () {
      api.rerender('0ce66cd6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/card/CustomisedRequestCard.vue"
export default component.exports